import { render, staticRenderFns } from "./ExaminationList2.vue?vue&type=template&id=b24962de&"
import script from "./ExaminationList2.vue?vue&type=script&lang=js&"
export * from "./ExaminationList2.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationList2.vue?vue&type=style&index=0&id=b24962de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports